module.exports = angular.module('msi.layout.states', []).name;

angular.module(module.exports)
  .config(require('./root-state'))
  .run(require('./loading-state'));
